import React, { Component } from "react";
import { connect } from "react-redux";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import { setSeatAPIData } from "../actions/main.js";
import { CookieName, getCookie, setCookie } from "../utils/cookieManager";
import "../App.scss";
import ReactGA from "react-ga";

class BuslistCard extends Component {
  handleOnClick = bus => {
    let usertoken = getCookie(CookieName.USERTOKEN);

    //----- phonepe sdk -------//
    if (!usertoken) {
      if (!window.PhonePe) {
        const script = document.createElement("script");
        script.src =
          "https://www.confirmtkt.com/phonepe-js-sdk-0.3.17/bundle.js";
        script.async = true;

        script.onload = () => {
          if (!getCookie(CookieName.USERTEMPTOKEN)) {
            this.generateTokenFromPhonePeGrant(bus);
          }
        };
        document.body.appendChild(script);
      } else {
        if (!getCookie(CookieName.USERTEMPTOKEN)) {
          this.generateTokenFromPhonePeGrant(bus);
        }
      }
    }

    //----- phonepe sdk ends -------//

    const sourceId = this.props.info.source.masterId;
    const destinationId = this.props.info.destination.masterId;
    const doj = this.props.info.doj;
    let seatapidata = {
      sid: sourceId,
      did: destinationId,
      doj: doj,
      bus,
      isAPSRTC: bus.Provider === "APSRTC" ? true : false
    };
    this.props.setSeatAPIData(seatapidata);
    this.props.history.push({
      pathname: "/bus-booking-phonepe/seat-select/"
    });
  };

  generateTokenFromPhonePeGrant = bus => {
    let operatingSystem = window.PhonePe.Constants.OS.android;
    window.PhonePe.PhonePe.loggingEnabled = true;
    window.PhonePe.PhonePe.build(
      window.PhonePe.Constants.Species.web,
      operatingSystem
    ).then(sdk => {
      sdk
        .fetchAuthToken()
        .then(res => {
          console.log("token granter");
          this.setState({ phonepeToken: res.grantToken });
          //call server side api and get confirmtkt token
          return res.grantToken;
        })
        .then(phonepeGrantToken => {
          const tokenUrl = `https://securedapi.confirmtkt.com//api/platform/authenticatephonepe?grantToken=${phonepeGrantToken}`;
          fetch(tokenUrl)
            .then(res => res.json())
            .then(res => {
              setCookie(CookieName.USERTOKEN, res.userKey, 60);
              setCookie(CookieName.USERTEMPTOKEN, res.TempToken, 60);
              setCookie(CookieName.USERNAME, res.Name, 60);
              setCookie(CookieName.USERMOBILE, res.PhoneNumber, 60);
              setCookie(CookieName.USERIMG, res.ProfileImage, 60);
              setCookie(CookieName.USEREMAIL, res.Email, 60);
              ReactGA.event({
                category: "login",
                action: "login-otp-verified-success"
              });
            });
        })
        .catch(err => {
          console.log("Error occured while fetching the grant token");

          const sourceId = this.props.info.source.masterId;
          const destinationId = this.props.info.destination.masterId;
          const doj = this.props.info.doj;
          let seatapidata = {
            sid: sourceId,
            did: destinationId,
            doj: doj,
            bus,
            isAPSRTC: bus.Provider === "APSRTC" ? true : false
          };
          this.props.setSeatAPIData(seatapidata);
          this.props.history.push({
            pathname: "/bus-booking-phonepe/account-login",
            state: { defaultPath: "/bus-booking-phonepe/seat-select" }
          });
        });
    });
  };

  render() {
    let bus = this.props.busobj.buses;
    if (bus && bus.length > 0 && bus[0].hasOwnProperty("isRTC")) {
      bus = bus.slice(1);
    }
    const busblock = bus.map(bus => {
      return (
        <div key={bus.Id} id={bus.Id} onClick={e => this.handleOnClick(bus)}>
          <Card className="bus-card">
            <CardContent className="card-content">
              <div className="row">
                <div className="column">
                  <div>{bus.TravelsName}</div>
                  <div className="bus-type">{bus.Type}</div>
                  <div className="duration">
                    <span className="dtime">{bus.DepartureTime}</span>
                    <i className="arrow">→</i>
                    <span className="atime">{bus.ArrivalTime}</span>
                  </div>
                </div>
                <div className="column1">
                  <div className="price">Rs {bus.Fare.TotalFare}</div>
                  <div>{bus.AvailableSeats} Seats</div>
                  <div>{bus.Duration} Hrs</div>
                </div>
              </div>
            </CardContent>
          </Card>
        </div>
      );
    });

    return <div>{busblock}</div>;
  }
}

const mapDispatchToProps = dispatch => {
  return {
    setSeatAPIData: query => {
      dispatch(setSeatAPIData(query));
    }
  };
};

export default connect(null, mapDispatchToProps)(BuslistCard);
